import { render } from "./ChildrenTree.vue?vue&type=template&id=763566bf"
import script from "./ChildrenTree.vue?vue&type=script&lang=js"
export * from "./ChildrenTree.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__